module.exports = __webpack_public_path__ + "static/media/DSC_0182.66a2a84d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0182.jpg
// module id = 641
// module chunks = 0